/* tslint:disable */
/* eslint-disable */
/**
 * Zalaris Benchmarks Position API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Error envelope for AI-related failures (extends ErrorResponse)
 */
export interface AIError {
    'status'?: number;
    'timestamp'?: string;
    'path'?: string;
    'errors'?: Array<ErrorEntry>;
    /**
     * Sanitized prompt that was sent to the AI
     */
    'prompt'?: string;
    /**
     * Raw AI response body for debugging
     */
    'raw_response'?: string;
    /**
     * Parse or validation error details
     */
    'details'?: string;
}
/**
 * Base schema for AI-specific context parameters. This schema is reused across enrichment and generation contexts to allow overriding default AI prompt and provider selection.  Used in: - Position enrichment: PositionEnrichmentContext.ai - Benchmark generation: BenchmarkGenerationRequest.ai 
 */
export interface AiContextBase {
    /**
     * Specific AI prompt ID to use (overrides default)
     */
    'promptId'?: string;
    'provider'?: AiProvider;
}


/**
 * AI-specific enrichment context parameters. Allows overriding default AI prompt and provider selection during position enrichment. 
 */
export interface AiEnrichmentContext {
    /**
     * Specific AI prompt ID to use (overrides default)
     */
    'promptId'?: string;
    'provider'?: AiProvider;
}



export const AiProvider = {
    Openai: 'openai',
    AzureOpenai: 'azure-openai'
} as const;

export type AiProvider = typeof AiProvider[keyof typeof AiProvider];


/**
 * Request body for bulk operations. - Omit \'ids\' or provide empty array to target all entities - Provide \'ids\' array with one or more IDs to target specific entities 
 */
export interface BulkOperationRequest {
    /**
     * Optional array of specific entity IDs to target for the operation. If not provided or empty, targets all entities. 
     */
    'ids'?: Array<string>;
}
/**
 * Enrichment provider identifier. - field-mapping: Applies field mapping configurations (highest priority) - job-classification: Enriches from job classification data based on jobCode (skills, competencies, experience, jobFunction) - country-codes: Enriches currency from country code (country-codes) - ai: AI-based enrichment (lowest priority, requires explicit selection) 
 */

export const EnrichmentProvider = {
    FieldMapping: 'field-mapping',
    JobClassification: 'job-classification',
    CountryCodes: 'country-codes',
    Ai: 'ai'
} as const;

export type EnrichmentProvider = typeof EnrichmentProvider[keyof typeof EnrichmentProvider];


export interface ErrorEntry {
    'code'?: string;
    'message'?: string;
}
/**
 * Generic error envelope used across services
 */
export interface ErrorResponse {
    'status'?: number;
    'timestamp'?: string;
    'path'?: string;
    'errors'?: Array<ErrorEntry>;
}
/**
 * This object defines how Position FieldMapping Enrichment specific context will be mapped by backend.
 */
export interface FieldMappingEnrichmentContext {
    /**
     * Ids of specific field mapping configs that should be applied.
     */
    'configIds'?: Array<string>;
}
export interface OperationResult {
    /**
     * Number of items successfully processed
     */
    'successCount': number;
    /**
     * Total number of items targeted for processing
     */
    'totalCount': number;
    /**
     * Number of items that failed processing
     */
    'failedCount': number;
}
export interface Position {
    'id'?: string;
    /**
     * Position code from SuccessFactors
     */
    'code': string;
    /**
     * Position title
     */
    'positionTitle'?: string;
    /**
     * Effective start date and time
     */
    'effectiveStartDate': string;
    /**
     * Company name
     */
    'company'?: string;
    /**
     * Location/office
     */
    'location'?: string;
    /**
     * Job title
     */
    'jobTitle'?: string;
    /**
     * Department
     */
    'department'?: string;
    /**
     * Division
     */
    'division'?: string;
    /**
     * Job classification code linking to job classification
     */
    'jobCode'?: string;
    /**
     * Business unit code
     */
    'businessUnit'?: string;
    /**
     * Cost center code
     */
    'costCenter'?: string;
    /**
     * Pay grade
     */
    'payGrade'?: string;
    /**
     * Pay range
     */
    'payRange'?: string | null;
    /**
     * Job level classification
     */
    'jobLevel'?: string;
    /**
     * Employee class code
     */
    'employeeClass'?: string;
    /**
     * Target full-time equivalent
     */
    'targetFTE'?: string;
    /**
     * Effective end date and time
     */
    'effectiveEndDate'?: string;
    /**
     * Effective status
     */
    'effectiveStatus'?: string;
    /**
     * List of required technical skills
     */
    'skillsRequired'?: Array<string>;
    /**
     * List of required competencies
     */
    'competencesRequired'?: Array<string>;
    /**
     * Required years of experience (e.g., \"5-8 years\", \"8+ years\")
     */
    'expectedExperienceYears'?: string;
    /**
     * Country name
     */
    'country'?: string;
    /**
     * Currency code
     */
    'currency'?: string;
    /**
     * Primary job function/category (e.g., \"Engineering\", \"Sales\", \"Finance\")
     */
    'jobFunction'?: string;
    /**
     * Required education level (e.g., \"Bachelor\'s Degree\", \"Master\'s Degree\")
     */
    'expectedEducationLevel'?: string;
    /**
     * Whether the position is vacant
     */
    'vacant'?: boolean;
    /**
     * Whether this position manages people
     */
    'peopleManager'?: boolean | null;
    /**
     * Whether this position is eligible for bonuses
     */
    'bonusApplicable'?: boolean | null;
    /**
     * Maximum performance bonus percentage
     */
    'performanceBonusMax'?: number | null;
    /**
     * Maximum commission bonus percentage
     */
    'commissionBonusMax'?: number | null;
    /**
     * Custom attributes map for dynamic properties. Additional custom properties can be stored here. 
     */
    'customAttributes'?: { [key: string]: any; };
}
/**
 * Request body for bulk enrichment with optional enrichment context and bulk operation targeting. Combines BulkOperationRequest (for targeting positions) with PositionEnrichmentContext (for provider configs). 
 */
export interface PositionEnrichmentRequest {
    [key: string]: any;

    /**
     * Optional array of specific entity IDs to target for the operation. If not provided or empty, targets all entities. 
     */
    'ids'?: Array<string>;
}
/**
 * Field mapping configuration that maps source field values to target field values
 */
export interface PositionFieldMappingConfig {
    /**
     * Unique identifier of the configuration
     */
    'id'?: string;
    /**
     * Name of the mapping configuration
     */
    'name': string;
    /**
     * Description of what this mapping does
     */
    'description'?: string;
    /**
     * Target field name where mapped values will be stored (can be a Position entity field or customAttribute)
     */
    'targetField': string;
    /**
     * Source field name to read values from (can be a Position entity field or customAttribute)
     */
    'sourceField': string;
    /**
     * Whether this configuration is enabled
     */
    'enabled'?: boolean;
    /**
     * Priority/order for applying mappings (higher number wins when multiple configs target same field)
     */
    'priority'?: number;
    /**
     * Whether to overwrite existing values. If false, mapping is skipped when target field already has a value
     */
    'overwrite'?: boolean;
    /**
     * List of value mappings (sourceValue -> targetValue)
     */
    'mappings': Array<PositionFieldMappingValue>;
}
/**
 * Simple value mapping from source value to target value
 */
export interface PositionFieldMappingValue {
    /**
     * Source value to match
     */
    'sourceValue': string;
    /**
     * Target value to set when source matches
     */
    'targetValue': string;
}
export interface TaskCreateResponse {
    'taskId': string;
}

/**
 * PositionApi - axios parameter creator
 */
export const PositionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a single position
         * @param {string} id Unique identifier of the position
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePosition: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePosition', 'id', id)
            const localVarPath = `/api/positions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one, multiple, or all positions based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific positions. Omit \'ids\' or provide empty array to delete all positions (requires elevated permissions). 
         * @summary Delete positions (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePositionsBulk: async (bulkOperationRequest: BulkOperationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkOperationRequest' is not null or undefined
            assertParamExists('deletePositionsBulk', 'bulkOperationRequest', bulkOperationRequest)
            const localVarPath = `/api/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkOperationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enrich a position using multiple enrichment providers. By default, all providers are used (field-mapping, job-classification, country-codes). AI provider requires explicit selection. 
         * @summary Enrich a single position
         * @param {string} id Unique identifier of the position
         * @param {Array<EnrichmentProvider>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers except AI are used.
         * @param {{ [key: string]: any; }} [requestBody] Optional provider-specific enrichment context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrichPosition: async (id: string, providers?: Array<EnrichmentProvider>, requestBody?: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enrichPosition', 'id', id)
            const localVarPath = `/api/positions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (providers) {
                localVarQueryParameter['providers'] = providers.join(COLLECTION_FORMATS.csv);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk enrich positions using multiple enrichment providers. By default, all providers are used (field-mapping, job-classification, country-codes). AI provider requires explicit selection. 
         * @summary Enrich positions (bulk operation, async)
         * @param {Array<EnrichmentProvider>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers except AI are used.
         * @param {PositionEnrichmentRequest} [positionEnrichmentRequest] Optional bulk operation targeting and provider-specific enrichment context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrichPositionsBulk: async (providers?: Array<EnrichmentProvider>, positionEnrichmentRequest?: PositionEnrichmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (providers) {
                localVarQueryParameter['providers'] = providers.join(COLLECTION_FORMATS.csv);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionEnrichmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single position by ID
         * @param {string} id Unique identifier of the position
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPosition', 'id', id)
            const localVarPath = `/api/positions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all positions. Client-side filtering and sorting supported in frontend.
         * @summary List all positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a position
         * @param {string} id Unique identifier of the position
         * @param {Position} position 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePosition: async (id: string, position: Position, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePosition', 'id', id)
            // verify required parameter 'position' is not null or undefined
            assertParamExists('updatePosition', 'position', position)
            const localVarPath = `/api/positions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(position, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PositionApi - functional programming interface
 */
export const PositionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PositionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a single position
         * @param {string} id Unique identifier of the position
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePosition(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePosition(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.deletePosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one, multiple, or all positions based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific positions. Omit \'ids\' or provide empty array to delete all positions (requires elevated permissions). 
         * @summary Delete positions (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePositionsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePositionsBulk(bulkOperationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.deletePositionsBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enrich a position using multiple enrichment providers. By default, all providers are used (field-mapping, job-classification, country-codes). AI provider requires explicit selection. 
         * @summary Enrich a single position
         * @param {string} id Unique identifier of the position
         * @param {Array<EnrichmentProvider>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers except AI are used.
         * @param {{ [key: string]: any; }} [requestBody] Optional provider-specific enrichment context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrichPosition(id: string, providers?: Array<EnrichmentProvider>, requestBody?: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enrichPosition(id, providers, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.enrichPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk enrich positions using multiple enrichment providers. By default, all providers are used (field-mapping, job-classification, country-codes). AI provider requires explicit selection. 
         * @summary Enrich positions (bulk operation, async)
         * @param {Array<EnrichmentProvider>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers except AI are used.
         * @param {PositionEnrichmentRequest} [positionEnrichmentRequest] Optional bulk operation targeting and provider-specific enrichment context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrichPositionsBulk(providers?: Array<EnrichmentProvider>, positionEnrichmentRequest?: PositionEnrichmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enrichPositionsBulk(providers, positionEnrichmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.enrichPositionsBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a single position by ID
         * @param {string} id Unique identifier of the position
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPosition(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPosition(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.getPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all positions. Client-side filtering and sorting supported in frontend.
         * @summary List all positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPositions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Position>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPositions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.listPositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a position
         * @param {string} id Unique identifier of the position
         * @param {Position} position 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePosition(id: string, position: Position, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePosition(id, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.updatePosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PositionApi - factory interface
 */
export const PositionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PositionApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a single position
         * @param {string} id Unique identifier of the position
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePosition(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePosition(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one, multiple, or all positions based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific positions. Omit \'ids\' or provide empty array to delete all positions (requires elevated permissions). 
         * @summary Delete positions (bulk operation)
         * @param {BulkOperationRequest} bulkOperationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePositionsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperationResult> {
            return localVarFp.deletePositionsBulk(bulkOperationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Enrich a position using multiple enrichment providers. By default, all providers are used (field-mapping, job-classification, country-codes). AI provider requires explicit selection. 
         * @summary Enrich a single position
         * @param {string} id Unique identifier of the position
         * @param {Array<EnrichmentProvider>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers except AI are used.
         * @param {{ [key: string]: any; }} [requestBody] Optional provider-specific enrichment context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrichPosition(id: string, providers?: Array<EnrichmentProvider>, requestBody?: { [key: string]: any; }, options?: RawAxiosRequestConfig): AxiosPromise<Position> {
            return localVarFp.enrichPosition(id, providers, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk enrich positions using multiple enrichment providers. By default, all providers are used (field-mapping, job-classification, country-codes). AI provider requires explicit selection. 
         * @summary Enrich positions (bulk operation, async)
         * @param {Array<EnrichmentProvider>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers except AI are used.
         * @param {PositionEnrichmentRequest} [positionEnrichmentRequest] Optional bulk operation targeting and provider-specific enrichment context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrichPositionsBulk(providers?: Array<EnrichmentProvider>, positionEnrichmentRequest?: PositionEnrichmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskCreateResponse> {
            return localVarFp.enrichPositionsBulk(providers, positionEnrichmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single position by ID
         * @param {string} id Unique identifier of the position
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Position> {
            return localVarFp.getPosition(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all positions. Client-side filtering and sorting supported in frontend.
         * @summary List all positions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositions(options?: RawAxiosRequestConfig): AxiosPromise<Array<Position>> {
            return localVarFp.listPositions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a position
         * @param {string} id Unique identifier of the position
         * @param {Position} position 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePosition(id: string, position: Position, options?: RawAxiosRequestConfig): AxiosPromise<Position> {
            return localVarFp.updatePosition(id, position, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PositionApi - object-oriented interface
 */
export class PositionApi extends BaseAPI {
    /**
     * 
     * @summary Delete a single position
     * @param {string} id Unique identifier of the position
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePosition(id: string, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).deletePosition(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one, multiple, or all positions based on request body. Use {ids: [\"id1\", \"id2\"]} to delete specific positions. Omit \'ids\' or provide empty array to delete all positions (requires elevated permissions). 
     * @summary Delete positions (bulk operation)
     * @param {BulkOperationRequest} bulkOperationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePositionsBulk(bulkOperationRequest: BulkOperationRequest, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).deletePositionsBulk(bulkOperationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enrich a position using multiple enrichment providers. By default, all providers are used (field-mapping, job-classification, country-codes). AI provider requires explicit selection. 
     * @summary Enrich a single position
     * @param {string} id Unique identifier of the position
     * @param {Array<EnrichmentProvider>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers except AI are used.
     * @param {{ [key: string]: any; }} [requestBody] Optional provider-specific enrichment context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public enrichPosition(id: string, providers?: Array<EnrichmentProvider>, requestBody?: { [key: string]: any; }, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).enrichPosition(id, providers, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk enrich positions using multiple enrichment providers. By default, all providers are used (field-mapping, job-classification, country-codes). AI provider requires explicit selection. 
     * @summary Enrich positions (bulk operation, async)
     * @param {Array<EnrichmentProvider>} [providers] Comma-separated list of provider IDs to use. If not specified, all providers except AI are used.
     * @param {PositionEnrichmentRequest} [positionEnrichmentRequest] Optional bulk operation targeting and provider-specific enrichment context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public enrichPositionsBulk(providers?: Array<EnrichmentProvider>, positionEnrichmentRequest?: PositionEnrichmentRequest, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).enrichPositionsBulk(providers, positionEnrichmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single position by ID
     * @param {string} id Unique identifier of the position
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPosition(id: string, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).getPosition(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all positions. Client-side filtering and sorting supported in frontend.
     * @summary List all positions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPositions(options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).listPositions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a position
     * @param {string} id Unique identifier of the position
     * @param {Position} position 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePosition(id: string, position: Position, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).updatePosition(id, position, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PositionFieldMappingApi - axios parameter creator
 */
export const PositionFieldMappingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new field mapping configuration
         * @param {PositionFieldMappingConfig} positionFieldMappingConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPositionFieldMapping: async (positionFieldMappingConfig: PositionFieldMappingConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionFieldMappingConfig' is not null or undefined
            assertParamExists('createPositionFieldMapping', 'positionFieldMappingConfig', positionFieldMappingConfig)
            const localVarPath = `/api/positions/field-mappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionFieldMappingConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a field mapping configuration
         * @param {string} id Unique identifier of the field mapping configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePositionFieldMapping: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePositionFieldMapping', 'id', id)
            const localVarPath = `/api/positions/field-mappings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a field mapping configuration by ID
         * @param {string} id Unique identifier of the field mapping configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionFieldMapping: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPositionFieldMapping', 'id', id)
            const localVarPath = `/api/positions/field-mappings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all field mapping configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositionFieldMappings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/positions/field-mappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a field mapping configuration
         * @param {string} id Unique identifier of the field mapping configuration
         * @param {PositionFieldMappingConfig} positionFieldMappingConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePositionFieldMapping: async (id: string, positionFieldMappingConfig: PositionFieldMappingConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePositionFieldMapping', 'id', id)
            // verify required parameter 'positionFieldMappingConfig' is not null or undefined
            assertParamExists('updatePositionFieldMapping', 'positionFieldMappingConfig', positionFieldMappingConfig)
            const localVarPath = `/api/positions/field-mappings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionFieldMappingConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PositionFieldMappingApi - functional programming interface
 */
export const PositionFieldMappingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PositionFieldMappingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new field mapping configuration
         * @param {PositionFieldMappingConfig} positionFieldMappingConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPositionFieldMapping(positionFieldMappingConfig: PositionFieldMappingConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionFieldMappingConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPositionFieldMapping(positionFieldMappingConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionFieldMappingApi.createPositionFieldMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a field mapping configuration
         * @param {string} id Unique identifier of the field mapping configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePositionFieldMapping(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePositionFieldMapping(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionFieldMappingApi.deletePositionFieldMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a field mapping configuration by ID
         * @param {string} id Unique identifier of the field mapping configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionFieldMapping(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionFieldMappingConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionFieldMapping(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionFieldMappingApi.getPositionFieldMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all field mapping configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPositionFieldMappings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PositionFieldMappingConfig>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPositionFieldMappings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionFieldMappingApi.listPositionFieldMappings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a field mapping configuration
         * @param {string} id Unique identifier of the field mapping configuration
         * @param {PositionFieldMappingConfig} positionFieldMappingConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePositionFieldMapping(id: string, positionFieldMappingConfig: PositionFieldMappingConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionFieldMappingConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePositionFieldMapping(id, positionFieldMappingConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionFieldMappingApi.updatePositionFieldMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PositionFieldMappingApi - factory interface
 */
export const PositionFieldMappingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PositionFieldMappingApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new field mapping configuration
         * @param {PositionFieldMappingConfig} positionFieldMappingConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPositionFieldMapping(positionFieldMappingConfig: PositionFieldMappingConfig, options?: RawAxiosRequestConfig): AxiosPromise<PositionFieldMappingConfig> {
            return localVarFp.createPositionFieldMapping(positionFieldMappingConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a field mapping configuration
         * @param {string} id Unique identifier of the field mapping configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePositionFieldMapping(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePositionFieldMapping(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a field mapping configuration by ID
         * @param {string} id Unique identifier of the field mapping configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionFieldMapping(id: string, options?: RawAxiosRequestConfig): AxiosPromise<PositionFieldMappingConfig> {
            return localVarFp.getPositionFieldMapping(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all field mapping configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositionFieldMappings(options?: RawAxiosRequestConfig): AxiosPromise<Array<PositionFieldMappingConfig>> {
            return localVarFp.listPositionFieldMappings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a field mapping configuration
         * @param {string} id Unique identifier of the field mapping configuration
         * @param {PositionFieldMappingConfig} positionFieldMappingConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePositionFieldMapping(id: string, positionFieldMappingConfig: PositionFieldMappingConfig, options?: RawAxiosRequestConfig): AxiosPromise<PositionFieldMappingConfig> {
            return localVarFp.updatePositionFieldMapping(id, positionFieldMappingConfig, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PositionFieldMappingApi - object-oriented interface
 */
export class PositionFieldMappingApi extends BaseAPI {
    /**
     * 
     * @summary Create a new field mapping configuration
     * @param {PositionFieldMappingConfig} positionFieldMappingConfig 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPositionFieldMapping(positionFieldMappingConfig: PositionFieldMappingConfig, options?: RawAxiosRequestConfig) {
        return PositionFieldMappingApiFp(this.configuration).createPositionFieldMapping(positionFieldMappingConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a field mapping configuration
     * @param {string} id Unique identifier of the field mapping configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePositionFieldMapping(id: string, options?: RawAxiosRequestConfig) {
        return PositionFieldMappingApiFp(this.configuration).deletePositionFieldMapping(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a field mapping configuration by ID
     * @param {string} id Unique identifier of the field mapping configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPositionFieldMapping(id: string, options?: RawAxiosRequestConfig) {
        return PositionFieldMappingApiFp(this.configuration).getPositionFieldMapping(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all field mapping configurations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPositionFieldMappings(options?: RawAxiosRequestConfig) {
        return PositionFieldMappingApiFp(this.configuration).listPositionFieldMappings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a field mapping configuration
     * @param {string} id Unique identifier of the field mapping configuration
     * @param {PositionFieldMappingConfig} positionFieldMappingConfig 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePositionFieldMapping(id: string, positionFieldMappingConfig: PositionFieldMappingConfig, options?: RawAxiosRequestConfig) {
        return PositionFieldMappingApiFp(this.configuration).updatePositionFieldMapping(id, positionFieldMappingConfig, options).then((request) => request(this.axios, this.basePath));
    }
}



